import { Api } from '../typings/api';

export enum Format {
	SmartphonePortrait = 'only screen and (max-width : 480px)',
	SmartphoneLandscape = 'only screen and (min-width : 481px) and (max-width : 767px)',
	Smartphone = 'only screen and (max-width : 767px)',
	TabletPortrait = 'only screen and (min-width : 768px) and (max-width : 991px) and (orientation : portrait)',
	TabletLandscape = 'only screen and (min-width : 768px) and (max-width : 991px) and (orientation : landscape)',
	Tablet = 'only screen and (min-width : 768px) and (max-width : 991px)',
	SmallDesktop = 'only screen and (min-width : 992px) and (max-width : 1199px)',
	LargeDesktop = 'only screen and (min-width : 1200px)'
}

export interface ResolveTemplate extends Api.Template {
	commonStyles: ResolveCommonStyles;
}

export interface ResolveCommonStyles extends Api.CommonStyles {
	primary: Api.PrimaryStyle;
}

export const StyleColor: { [k: string]: string } = {
	Blue: '#2c9bf3',
	LightBlue: '#f5faff',
	Red: '#f14d4d',
	LightRed: '#f47171',
	Green: '#40d775',
	Yellow: '#ffc300',
	White: '#ffffff',
	Black: '#000000',
	Grey50: '#f3f3f3',
	Grey100: '#e8e8e8',
	Grey200: '#d9d9d9',
	Grey300: '#cecece',
	Grey400: '#c3c3c3',
	Grey500: '#8c8c8c',
	Grey600: '#666666',
	Grey650: '#555555',
	Grey700: '#404040',
	Grey800: '#292929',
	Grey900: '#1e1e1e'
};

export const defaultTemplate: ResolveTemplate = {
	commonStyles: {
		primary: {
			actionColor: '#469bd7' ,
			backgroundColor: StyleColor.Grey50,
			cardColor: StyleColor.White,
			contentColor: StyleColor.Grey500,
			spacerColor: StyleColor.Grey300,
			strongColor: StyleColor.Grey800,
			topnavColor: StyleColor.White,
			iconsColor: StyleColor.Black,
			topnavOpacity: 100
		}
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/styles-constants.ts